import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const TICKET_PRICE = process.env.VUE_APP_TICKET_PRICE;
const CURRENCY_CODE = process.env.VUE_APP_CURRENCY_CODE;
export default new Vuex.Store({
  state: {
    isLoggedIn: !!localStorage.getItem('access_token'),
    type: 'standard',
    tickets: [],
    ticketsLength: 0, // use for combination pick
    totalAmount: 0,
  },
  mutations: {
    loginUser(state) {
      state.isLoggedIn = true;
    },
    logoutUser(state) {
      state.isLoggedIn = false;
    },
    updateTickets(state, tickets) {
      state.tickets = tickets;
      state.totalAmount = tickets.length * TICKET_PRICE;
    },
    updateTotalAmount(state, ticketLength: number) {
      state.ticketsLength = ticketLength;
      state.totalAmount = ticketLength * TICKET_PRICE;
    },
    updateTicketType(state, type) {
      state.type = type;
    }
  },
  actions: {
    addOrUpdateTickets({commit, state}, tickets: Array<any>) {
      const finalTickets: any[] = [];
      let ticket: number[][];

      tickets.forEach(function (item: Array<any>) {
        ticket = [
            [],
            []
        ];
        item.forEach(function(n: any, j: number) {
          if (n.active) {
            ticket[0].push(j+1);
          }
        });
        if (ticket[0].length) {
          finalTickets.push(ticket);
        }

      });
      console.log('finalTickets', finalTickets);
      commit('updateTickets', finalTickets);
    },
    updateTicketType({commit, state}, type: string) {
      commit('updateTicketType', type);
    },
    updateTotalAmount({commit, state}, ticketLength: number) {
      commit('updateTotalAmount', ticketLength);
    },
  },
  modules: {
  },
  getters: {
    getToken: (state) => state.isLoggedIn,
    getTicketsLength: (state) => {
      return state.tickets.length;
    },
    getTotalAmount: (state) => CURRENCY_CODE + " " + state.totalAmount.toFixed(2)
  },
});
